import { ClientTypes } from '~/constants/clientTypes';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { TAddress, TLicense, TPersonalDocument } from '../../types';

export type TGeneralInfoLegalResident = {
  'CRS-E': string | null;
  address: TAddress;
  financialPhone: string | null;
  contactNumbers: string[];
  emailAddress: string[];
  employeeCount: string | null;
  foreignLegalEntity: boolean | null;
  fullNameEng: string;
  fullNameUkr: string;
  hasForeignShare: boolean | null;
  isForeignFinancialUnderFATCA: boolean | null;
  isOtherTaxResident: boolean | null;
  isControllingPersonTaxResidentOtherJurisdiction: boolean | null;
  isUSTaxResident: boolean | null;
  questionnaire: Record<string, boolean>;
  shortNameUkr: string;
  type: ClientTypes;
  verification: number;
};

export type TGeneralInfoSoleTrader = {
  'CRS-I': string | null;
  address: TAddress & {
    birthplaceCountry: TAutocompleteOption | null;
    citizenshipCountry: TAutocompleteOption | null;
    residenceCountry: TAutocompleteOption | null;
  };
  birthDate: string;
  birthPlace: string | null;
  businessabroad: string | null;
  cerOfLossOfUSCitizenship: string | null;
  financialPhone: string | null;
  contactNumbers: string[];
  documents: TPersonalDocument;
  emailAddress: string[];
  explainRegardingLackOfUSCitizenship: boolean | null;
  foreignLegalEntity: null;
  fullName: string | null;
  fullNameInEng: string | null;
  isOtherTaxResident: boolean | null;
  isUSTaxResident: boolean | null;
  license: boolean;
  licenses: TLicense[];
  questionnaire: Record<string, boolean>;
  shortNameUkr: string | null;
  taxIdentNumber: string | null;
  taxstatusinternation: string | null;
  type: ClientTypes;
  uniqueDemographicRecordNumber: string | null;
  verification: number;
};

export type TGeneralInfoAssetManager = {
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  address: TAddress;
  birthDate: string | null;
  birthPlace: string | null;
  birthplaceCountry: TAutocompleteOption | null;
  citizenshipCountry: TAutocompleteOption | null;
  residenceCountry: TAutocompleteOption | null;
  contactNumbers: string[];
  documents: TPersonalDocument;
  emailAddress: string[];
  foreignLegalEntity: boolean | null;
  foreignTaxNumber: string | null;
  identificationNumber: string | null;
  isDataProcessingAccepted: boolean | null;
  isOtherTaxResident: boolean | null;
  isUSTaxResident: boolean | null;
  questionnaire: Record<string, boolean>;
  shortNameUkr: string | null;
  type: ClientTypes;
  verification: number;
  verificationStatus: string;
};

export type TGeneralInfo =
  TGeneralInfoSoleTrader | TGeneralInfoAssetManager | TGeneralInfoLegalResident;

export type TAddressType = 'registrationAddress' | 'permanentAddress';

export enum AddressTypes {
  registrationAddress = 'registrationAddress',
  permanentAddress = 'permanentAddress',
}
